"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { Project } from "./ProjectData";

interface ProjectCardProps {
  project: Project;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
  const projectSlug = project.title.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className="relative group flex h-[420px] w-[310px] flex-col justify-between rounded-md bg-white p-3 shadow-lg hover:shadow-xl dark:border dark:border-primary/30 dark:bg-transparent overflow-hidden">
      {/* Image and content */}
      <Link href={`/projects/${projectSlug}`} className="flex flex-col gap-3 h-full">
        {/* Project Image */}
        <div className="h-[55%]">
          <Image
            src={project.image}
            alt={project.title}
            width={300}
            height={200}
            className="h-full w-full rounded-md object-cover"
            loading="eager"
          />
        </div>

        {/* Title and Description */}
        <div className="flex flex-col gap-2">
          <h3 className="line-clamp-2 font-semibold text-base text-gray-800 dark:text-white">
            {project.title}
          </h3>
          <p className="text-sm text-body-color dark:text-body-color-dark line-clamp-2 mb-2">
            {project.description}
          </p>
          
          {/* Categories Tags */}
          <div className="flex flex-wrap gap-1.5">
            {project.categories.map((cat, idx) => (
              <span
                key={idx}
                className="rounded-full bg-primary/10 px-2 py-0.5 text-xs text-primary dark:bg-primary/20"
              >
                {cat}
              </span>
            ))}
          </div>
          
          {/* Technologies Tags */}
          <div className="flex flex-wrap gap-1.5 mt-1.5">
            {project.technologies.map((tech, idx) => (
              <span
                key={idx}
                className="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600 dark:bg-gray-700 dark:text-gray-300"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProjectCard;